import { env } from '../config.js';

export async function userLogin(mail,pass) {
    var data = {username: mail, password: pass};
    const response = await fetch(env.BACKEND_URL + '/authenticate',
    {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    }
    )
    .catch( () => {
        return {error: true};
    });

    return await response;
}

export async function changeUserSettings(token, mail, oldPass, newPass){
    var data = {username: mail, oldPassword: oldPass, newPassword: newPass};
    const response = await fetch(env.BACKEND_URL + '/user/edit',
    {
        method: 'POST',
        headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
        body: JSON.stringify(data)
    }
    );

    return await response;
}

export async function createUserInvite(token, isAdmin){
    const response = await fetch(env.BACKEND_URL + '/admin/invite/' + isAdmin,
    {
        method: 'GET',
        headers: {'Authorization': 'Bearer ' + token}
    }
    );

    return await response.text();
}

export async function registerUser(uuid, username, password){
    var data = {uuid: uuid, username: username, password: password};
    const response = await fetch(env.BACKEND_URL + '/register',
    {
        method: 'POST',
        headers: {
                    'Content-Type': 'application/json'
                },
        body: JSON.stringify(data)
    }
    );

    return await response;
}